export default __webpack_public_path__ + "static/media/Budgerigar.6a45cae0.jpg";